import { Actions } from "../actions";

import { pinsReducer } from "./reducers/pins";
import { recordsReducer } from "./reducers/records";
import { toolsReducer } from "./reducers/tools";
import { initialMapState, RouteMapState } from "./state";

export * from "./state";

export const mapReducer = (
  state: RouteMapState = initialMapState,
  action: Actions
): RouteMapState => recordsReducer(toolsReducer(pinsReducer(state, action), action), action);

export default mapReducer;
